// What the templates register shows of a template beyond its name
// (TC-UC27-02-01 rezultat_ui; docs/ui-shape-admin-aggregations-alerts.md §4.2, §12).

/** The languages a notification can be written in: the interface's own three. */
export const TEMPLATE_LOCALES = ['ro', 'ru', 'en'] as const;

export type TemplateLocale = (typeof TEMPLATE_LOCALES)[number];

const PREVIEW_LENGTH = 160;

/**
 * The body as one short line for the register: the lines of the template joined, runs of
 * whitespace collapsed, and a body longer than the preview cut at a word with an ellipsis.
 * The whole body stays available as the cell's `title`.
 */
export function bodyPreview(body: string, max: number = PREVIEW_LENGTH): string {
  const flat = body.replace(/\s+/g, ' ').trim();
  if (flat.length <= max) return flat;
  const cut = flat.slice(0, max);
  const lastSpace = cut.lastIndexOf(' ');
  return `${(lastSpace > max / 2 ? cut.slice(0, lastSpace) : cut).trimEnd()}…`;
}

/** The i18n key of a locale's name; a locale the register does not know is shown as stored. */
export function localeLabelKey(locale: string): string | null {
  return (TEMPLATE_LOCALES as readonly string[]).includes(locale)
    ? `alerts.templates.locale.${locale}`
    : null;
}
